
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/shosekika",
      function () {
        return require("private-next-pages/docs/shosekika.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/shosekika"])
      });
    }
  